import colors from 'constants/color'

const baseTheme = {
  typography: {
    fontFamily: 'Noto Sans',
    fontSize: 12,
  },
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    info: { main: colors.info },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none' as 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none' as 'none',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            fontSize: 24,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled' as 'filled',
      },
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            padding: '10px 12px',
          },
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: 'filled' as 'filled',
      },
      styleOverrides: {
        select: {
          padding: '10px 12px',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: '80px',
        },
      },
    },
  },
}

export default baseTheme
